<template>
  <div>
    <filter-item>
      <form-field-input
        label="Search"
        help-text="search by name, phone or email address"
        v-model="filterSearchValue"
      ></form-field-input>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Type"
        v-model="filterTypeValue"
      >
        <option :value="null">All Types</option>
        <option
          v-for="(type, index) in contactTypes"
          :value="type.id"
          :key="index"
        >
          {{ type.name }}
        </option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Tag"
        v-model="filterTagValue"
      >
        <option :value="null">All Tags</option>
        <option
          v-for="(tag, index) in contactTags"
          :value="tag.id"
          :key="index"
        >
          {{ tag.label }}
        </option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <form-field-input
        label="City"
        v-model="filterCityValue"
      ></form-field-input>
    </filter-item>

    <filter-item>
      <form-field-input
        label="State"
        v-model="filterStateValue"
      ></form-field-input>
    </filter-item>

    <filter-item>
      <filter-postcode
        :store-module="storeModule"
        :filter-name="filterName"
      ></filter-postcode>
    </filter-item>

    <filter-item>
      <form-field-select
        label="Include Seller"
        v-model="filterIncludeSellerValue"
      >
        <option :value="true">Yes</option>
        <option :value="false">No</option>
      </form-field-select>
    </filter-item>

    <filter-item>
      <filter-time-frames
        :store-module="storeModule"
        :filter-name="filterName"
      ></filter-time-frames>
    </filter-item>
  </div>
</template>

<script>
export default {
  name: "ContactsFilter",
  props: {
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      default: "contacts"
    }
  },
  computed: {
    contactTypes() {
      return this.$store.getters.contactTypes
    },
    contactTags() {
      return this.$store.getters.contactTags
    },
    filterSearchValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].search;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "search",
          value
        ]);
      }
    },
    filterTypeValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].type;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "type",
          value
        ]);
      }
    },
    filterTagValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].tag;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "tag",
          value
        ]);
      }
    },
    filterCityValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].city;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "city",
          value
        ]);
      }
    },
    filterStateValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].state;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "state",
          value
        ]);
      }
    },
    filterIncludeSellerValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].includeSeller;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "includeSeller",
          value
        ]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.filter_item {
  padding: 0 8px 12px !important;
}
</style>
